import React from 'react';
import Link from 'next/link';
import { Heart, ArrowRight, ShieldCheck } from 'lucide-react';

export default function HeroSection() {
  return (
    <section className="relative bg-gradient-to-br from-teal-700 via-teal-600 to-teal-500 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-20 w-96 h-96 bg-amber-400 rounded-full blur-3xl" />
      </div>
      <div className="relative max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 py-20 lg:py-28">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/20 backdrop-blur rounded-full text-white text-sm font-medium mb-6">
            <ShieldCheck size={14} />
            <span>All cases verified by our safeguarding team</span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-800 text-white leading-tight text-balance mb-6">
            Give directly to people{' '}
            <span className="text-amber-300">who need you most</span>
          </h1>
          <p className="text-lg text-teal-100 max-w-xl mb-8 leading-relaxed">
            Every cause on World Giving is verified, safeguarded, and 100% transparent. UK taxpayers can boost their donation by 25% with Gift Aid — at no extra cost.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              href="/homepage#causes"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-white text-teal-700 font-semibold rounded-xl hover:bg-teal-50 transition-all duration-150 active:scale-95 text-base"
            >
              <Heart size={18} />
              Find a Cause to Support
            </Link>
            <Link
              href="/beneficiary-application-form"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-white/20 backdrop-blur text-white font-semibold rounded-xl hover:bg-white/30 border border-white/30 transition-all duration-150 active:scale-95 text-base"
            >
              Apply for Support
              <ArrowRight size={18} />
            </Link>
          </div>
          <p className="mt-6 text-sm text-teal-200">
            Regulated by the Charity Commission for England and Wales
          </p>
        </div>
      </div>
    </section>
  );
}